import { useState } from 'react';

type Updater = (v?: boolean) => boolean;

const useUncontrolledHook = (value: boolean) => {
  return useState(value);
};
const useControlledHook = (value?: boolean) =>
  [
    value,
    (updater: Updater) => {
      updater(value);
    },
  ] as [boolean, (u: Updater) => void];

export const ModeHooks = {
  controlled: useControlledHook,
  uncontrolled: useUncontrolledHook,
};

export type CheckboxModeType = keyof typeof ModeHooks;
